import CourseTreeItem from "./CourseTreeItem";
import type { CoursesListProps } from "./types";

const CoursesList = ({ courses, customCourses, groups, nodeId, searchTerm }: CoursesListProps) => (
  <>
    {courses?.map((course) => (
      <CourseTreeItem key={`${nodeId}/c${course.id}`} course={course} nodeId={nodeId} searchTerm={searchTerm} />
    ))}
    {groups?.map((group) => (
      <CourseTreeItem key={`${nodeId}/g${group.id}`} group={group} nodeId={nodeId} searchTerm={searchTerm} />
    ))}
    {customCourses?.map((customCourse) => (
      <CourseTreeItem
        key={`${nodeId}/cc${customCourse.id}`}
        customCourse={customCourse}
        nodeId={nodeId}
        searchTerm={searchTerm}
      />
    ))}
  </>
);

export default CoursesList;
